$('#wpsl-search-input').on('keydown', function (e) {
  // 13 is enter button
  if (e.which === 13) {
    $('#wpsl-search-btn').trigger('click');
  }
});
